
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';

import { FulfillmentType } from '../../../types/ProductDelivery';
import { IProductGroupSelector } from '../../../types/Product';

import DotLoader from '../../../components/DotLoader.vue';
import FulfillmentOptionComponent from './FulfillmentOption.vue';
import FulfillmentOptionDisclaimer from './FulfillmentOptionDisclaimer.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import StockSubscriptionFormTrigger from './StockSubscriptionFormTrigger.vue';

@Component({
	name: 'StandardShipping',
	components: {
		FulfillmentOptionComponent,
		FulfillmentOptionLink,
		FulfillmentOptionDisclaimer,
		DotLoader,
		StockSubscriptionFormTrigger,
	}
})
export default class StandardShipping extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('product')
	readonly product: any;

	@Get('shippingMessage')
	readonly shippingMessage: string;

	@Get('remainingSelectors')
	readonly remainingSelectors: IProductGroupSelector[];

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('shippingLoading')
	readonly shippingLoading: boolean;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('shippingError')
	readonly shippingError: string;

	@Get('shippingDeliveryDate')
	readonly shippingDeliveryDate: string;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isInStockOnline')
	readonly isInStockOnline: boolean;

	@Get('isShippingDisabled')
	readonly isShippingDisabled: boolean;

	@Get('inStoreOnly')
	readonly inStoreOnly: boolean;

	@Get('hasSelectorError')
	readonly hasSelectorError: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	get isDisabled(): boolean {
		return this.isShippingDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get estimatedDelivery() {
		return this.shippingDeliveryDate
			? `Expect it by ${this.shippingDeliveryDate}` : null;
	};

	get isSelected(): boolean {
		return !this.isDisabled && this.fulfillmentOption === this.selectedFulfillmentType;
	};

	get stockSubscriptionFormEnabled(): boolean {
		return this.product.backInStockInfo.isProductEligible &&
				!this.isInStockOnline &&
				!this.inStoreOnly &&
				this.hasSelectedVariant &&
				!this.fetchingProduct;
	}

	get disclaimer(): string | null {
		if (this.stockSubscriptionFormEnabled || this.inStoreOnly) {
			return null;
		}

		return this.product.eseText;
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.StandardShipping;

	/* Methods
	============================================*/
	onChange() {
		if (this.isSelected) return;
		this.$emit('change', this.fulfillmentOption);
	}

	/* Lifecycle Hooks
	============================================*/
	mounted() {
		if (!this.shippingDeliveryDate) {
			this.$store.dispatch('getShippingInfo');
		}
	}
}
